import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Group, SimpleGrid, Text } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";
import { Card, CashRegisterBadge } from "@prostocheck/ui";

import { IRegisterCardProps } from "./register-card.models";

export const RegisterCard = ({ register, isLoading }: IRegisterCardProps) => {
  const { t } = useTranslation();
  const { formatDateTime } = useFormatters();

  return (
    <Card>
      <Group
        justify="space-between"
        align="flex-start"
        gap="sm"
        wrap="nowrap"
      >
        <div className="min-w-0">
          <Link
            to={`/registers/${register.fiscalNumber}`}
            className="text-lg font-semibold text-ink-900 hover:text-brand-700"
          >
            {register.name}
          </Link>
          <Text size="sm" c="dimmed" mt={4}>
            {register.address}
          </Text>
        </div>
        <CashRegisterBadge state={register.state} />
      </Group>

      <SimpleGrid
        component="dl"
        cols={2}
        spacing="md"
        mt="lg"
        className="border-t border-ink-900/8 pt-4"
      >
        <div>
          <Text component="dt" size="sm" c="dimmed">
            {t("registers.fiscalNumber")}
          </Text>
          <Text component="dd" size="sm" fw={500} mt={2}>
            {register.fiscalNumber}
          </Text>
        </div>
        <div>
          <Text component="dt" size="sm" c="dimmed">
            {t("registers.localNumber")}
          </Text>
          <Text component="dd" size="sm" fw={500} mt={2}>
            {register.localNumber}
          </Text>
        </div>
        <div>
          <Text component="dt" size="sm" c="dimmed">
            {t("registers.shift")}
          </Text>
          <Text component="dd" size="sm" fw={500} mt={2}>
            {isLoading
              ? t("registers.loadingValue")
              : register.shiftState === "opened"
                ? t("registers.shiftOpened")
                : t("registers.shiftClosed")}
          </Text>
        </div>
        <div>
          <Text component="dt" size="sm" c="dimmed">
            {t("registers.lastZReport")}
          </Text>
          <Text component="dd" size="sm" fw={500} mt={2}>
            {isLoading
              ? t("registers.loadingValue")
              : register.lastZReportAt
                ? formatDateTime(register.lastZReportAt)
                : t("registers.noValue")}
          </Text>
        </div>
      </SimpleGrid>
    </Card>
  );
};
